<template>
  <div class="animated fadeIn">
    <b-card size="sm" footer-bg-variant="white" footer-border-variant="white">
      <div slot="header">
        <i class="icon-note"></i> Employee Detail
      </div>

      <b-card-body>
        <b-form id="employeeForm" validated novalidate @submit="editEmployee">
          <div v-if="loading == false">
            <b-row>
              <b-col sm="3">
                <b-form-group label-for="name" label="Nama Karyawan">
                  <b-form-input
                    id="name"
                    type="text"
                    v-model="$v.employeeForm.name.$model"
                    :state="!$v.employeeForm.name.$invalid"
                    required
                    placeholder="Nama Karyawan"
                  ></b-form-input>
                  <b-form-invalid-feedback>Nama karyawan harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="surename" label="Nama Panggilan">
                  <b-form-input
                    id="surename"
                    type="text"
                    v-model="$v.employeeForm.surename.$model"
                    :state="!$v.employeeForm.surename.$invalid"
                    placeholder="Nama Panggilan"
                  ></b-form-input>
                  <b-form-invalid-feedback>Nama panggilan harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="email" label="Email">
                  <b-form-input
                    id="email"
                    type="email"
                    v-model="$v.employeeForm.email.$model"
                    :state="!$v.employeeForm.email.$invalid"
                    required
                    placeholder="Email"
                  ></b-form-input>
                  <b-form-invalid-feedback>Email harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="mobile_phone" label="No HP">
                  <b-form-input
                    id="mobile_phone"
                    type="text"
                    v-model="$v.employeeForm.mobile_phone.$model"
                    :state="!$v.employeeForm.mobile_phone.$invalid"
                    required
                    placeholder="No. HP"
                  ></b-form-input>
                  <b-form-invalid-feedback>No. HP harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="3">
                <b-form-group label-for="division_id" label="Divisi">
                  <b-form-select
                    id="division_id"
                    :options="listDivisionEmployee"
                    v-model="$v.employeeForm.division_id.$model"
                    :isError="$v.employeeForm.division_id.$invalid"
                    @change="getPosition($event)"
                    placeholder="-- Harap pilih salah satu --"
                    required
                  ></b-form-select>
                  <b-form-invalid-feedback>Divisi harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="position_id" label="Posisi">
                  <b-form-select
                    id="position_id"
                    :options="listPositionEmployee"
                    v-model="$v.employeeForm.position_id.$model"
                    :isError="$v.employeeForm.position_id.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                    required
                  ></b-form-select>
                  <b-form-invalid-feedback>Posisi harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="payment_method" label="Metode Pembayaran">
                  <b-form-select
                    id="payment_method"
                    :options="listPaymentMethodEmployee"
                    v-model="$v.employeeForm.payment_method.$model"
                    :isError="$v.employeeForm.payment_method.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                    required
                  ></b-form-select>
                  <b-form-invalid-feedback>Metode pembayaran harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="bank_name" label="Nama Bank">
                  <b-form-input
                    id="bank_name"
                    type="text"
                    v-model="$v.employeeForm.bank_name.$model"
                    :state="!$v.employeeForm.bank_name.$invalid"
                    required
                    placeholder="Nama Bank"
                  ></b-form-input>
                  <b-form-invalid-feedback>Nama bank harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="3">
                <b-form-group label-for="bank_account_number" label="Nomor rekening">
                  <b-form-input
                    id="bank_account_number"
                    type="text"
                    v-model="$v.employeeForm.bank_account_number.$model"
                    :state="!$v.employeeForm.bank_account_number.$invalid"
                    required
                    placeholder="Nomor Rekening"
                  ></b-form-input>
                  <b-form-invalid-feedback>Nomor rekening harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="bank_account_name" label="Nama rekening">
                  <b-form-input
                    id="bank_account_name"
                    type="text"
                    v-model="$v.employeeForm.bank_account_name.$model"
                    :state="!$v.employeeForm.bank_account_name.$invalid"
                    required
                    placeholder="Nama Rekening"
                  ></b-form-input>
                  <b-form-invalid-feedback>Nama rekening harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="start_join" label="Tanggal Bergabung">
                  <v-date-picker
                    id="start_join"
                    :input-props="{ class: 'form-control', placeholder: 'Tanggal Bergabung', required: ''}"
                    :state="!$v.employeeForm.start_join.$invalid"
                    v-model="$v.employeeForm.start_join.$model"
                  ></v-date-picker>
                  <div
                    v-if="$v.employeeForm.start_join.$invalid"
                    class="invalid-feedback-custom"
                  >Tanggal bergabung harus di isi.</div>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="end_date" label="Tanggal Berakhir">
                  <v-date-picker
                    id="end_date"
                    :input-props="{ class: 'form-control', placeholder: 'Tanggal Berakhir'}"
                    :state="!$v.employeeForm.end_date.$invalid"
                    v-model="$v.employeeForm.end_date.$model"
                  ></v-date-picker>
                  <div
                    v-if="$v.employeeForm.end_date.$invalid"
                    class="invalid-feedback-custom"
                  >Tanggal berakhir harus di isi.</div>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <!-- <b-col sm="3">
                <b-form-group label-for="parent" label="Lapor Ke">
                  <b-form-select
                    id="parent"
                    v-model="$v.employeeForm.parent.$model"
                    :isError="$v.employeeForm.parent.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                  >
                    <optgroup
                      v-for="(list, key) in listParentEmployee"
                      v-bind:key="'parent_'+key"
                      v-bind:label="key"
                    >
                      <option
                        v-for="sub in list"
                        v-bind:value="sub.value"
                        v-bind:key="'sub_'+sub.value"
                      >{{sub.text}}</option>
                    </optgroup>
                  </b-form-select>
                </b-form-group>
              </b-col> -->

              <b-col sm="3">
                <b-form-group label-for="status" label="Status Karyawan">
                  <b-form-select
                    id="status"
                    :options="listStatusEmployee"
                    v-model="$v.employeeForm.status.$model"
                    :isError="$v.employeeForm.status.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                    required
                  ></b-form-select>
                  <b-form-invalid-feedback>Status karyawan harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <!-- <b-form-group label-for="shifting_status" label="Generate akses ke sistem">
                  <b-form-radio-group
                    id="shifting_status"
                    v-model="authorization"
                    :options="listGenerateAuthentication"
                    @change="generateAuth($event)"
                  ></b-form-radio-group>
                  <b-form-invalid-feedback>Generat akses ke sistem harus di isi.</b-form-invalid-feedback>
                </b-form-group> -->
                <b-form-group label-for="username" label="Username">
                  <b-form-input
                    id="username"
                    type="text"
                    v-model="$v.employeeForm.username.$model"
                    :state="!$v.employeeForm.username.$invalid"
                    required
                    placeholder="Username"
                  ></b-form-input>
                  <b-form-invalid-feedback>Username harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="shift" label="Shift Karyawan">
                  <b-form-select
                    id="shift"
                    :options="listEmployeeShift"
                    v-model="$v.employeeForm.shift.$model"
                    :isError="$v.employeeForm.shift.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                    required
                  ></b-form-select>
                  <b-form-invalid-feedback>Shift karyawan harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="religion" label="Agama">
                  <b-form-select
                    id="religion"
                    :options="listEmployeeReligion"
                    v-model="$v.employeeForm.religion.$model"
                    :isError="$v.employeeForm.religion.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                    required
                  ></b-form-select>
                  <b-form-invalid-feedback>Agama harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="3">
                <b-form-group label-for="id_number" label="No KTP">
                  <b-form-input
                    id="id_number"
                    type="text"
                    v-model="$v.employeeForm.id_number.$model"
                    :state="!$v.employeeForm.id_number.$invalid"
                    required
                    placeholder="No KTP"
                  ></b-form-input>
                  <b-form-invalid-feedback>No KTP harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="employee_ho" label="Lokasi Penempatan">
                  <b-form-select
                    id="employee_ho"
                    :options="listEmployeeHO"
                    v-model="$v.employeeForm.employee_ho.$model"
                    :isError="$v.employeeForm.employee_ho.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                    required
                  ></b-form-select>
                  <b-form-invalid-feedback>Lokasi penempatan harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="company" label="Karyawan Untuk PT">
                  <b-form-select
                    id="company"
                    :options="listCompany"
                    v-model="$v.employeeForm.company.$model"
                    :isError="$v.employeeForm.company.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                    required
                  ></b-form-select>
                  <b-form-invalid-feedback>Karyawan Untuk PT.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="6">
                <b-form-group label-for="address" label="Alamat">
                  <b-form-textarea
                    id="address"
                    :rows="3"
                    :max-rows="6"
                    v-model="$v.employeeForm.address.$model"
                    :state="!$v.employeeForm.address.$invalid"
                    required
                  ></b-form-textarea>
                  <b-form-invalid-feedback>Alamat harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <div class="text-right">
              <b-button type="button" size="sm" variant="danger" @click="back">
                <i class="fa fa-undo"></i> Back
              </b-button>&nbsp;
              <b-button
                type="submit"
                size="sm"
                variant="primary"
                :disabled="$v.employeeForm.$invalid"
              >
                <i class="fa fa-save"></i> Save
              </b-button>
            </div>
          </div>

          <div v-else>
            <loading></loading>
          </div>
        </b-form>
      </b-card-body>
    </b-card>

    <b-card size="sm" footer-bg-variant="white" footer-border-variant="white">
      <b-tabs>
        <b-tab title="Reset Password" active>
          <employee-forgot-password
            :nik="employeeForm.nik"
            :is-disable="(allowedResetPassword.includes(employeeForm.id)) ? true: false"
            :loading-param="loading"
          ></employee-forgot-password>
        </b-tab>
         <b-tab title="Access To System">
          <employee-config-access
            :nik="employeeForm.nik"
            :authorization="authorization"
            :loading-param="loading"
          ></employee-config-access>
        </b-tab>
        <b-tab title="Source Salary"  v-if="isShow">
          <employee-source-salary
            :nik="employeeForm.nik"
            :authorization="authorization"
            :loading-param="loading"
            :list-company="listCompanySourceSalary"
          ></employee-source-salary>
        </b-tab>

        <b-tab title="Mobile Device">
          <employee-mobile
            :nik="employeeForm.nik"
            :authorization="authorization"
            :loading-param="loading"
          ></employee-mobile>
        </b-tab>
      </b-tabs>
    </b-card> 
  </div>
</template>


<script>
import axios from "axios";
import globalTable from "../../templates/Table.vue";
import interfaces from "@/templates/_interfaces.js";
import custom_validation from "@/templates/_customValidation.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";
import EmployeeForgotPassword from "./tabs/EmployeeForgotPassword.vue";
import EmployeeConfigAccess from "./tabs/EmployeeConfigAccess.vue";
import EmployeeSourceSalary from "./tabs/EmployeeSourceSalary.vue";
import EmployeeMobile from "./tabs/EmployeeMobile.vue";

export default {
  name: "employee_detail",
  components: { globalTable, ModelSelect, loading, EmployeeForgotPassword, EmployeeConfigAccess, EmployeeSourceSalary, EmployeeMobile },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      allowedResetPassword: ['196', '325'],
      authorization: 1,
      employeeForm: interfaces.employee,
      listCompany: [],
      listCompanySourceSalary: [],
      listDivisionEmployee: [],
      listPositionEmployee: [],
      listPosition: [],
      listEmployeeHO: [],
      listPaymentMethodEmployee: [],
      listEmployeeReligion: [],
      listParentEmployee: [],
      listStatusEmployee: [],
      listEmployeeShift: [],
      listGenerateAuthentication: [
        { value: 1, text: "Tidak" },
        { value: 2, text: "Ya" }
      ],
      loading: true,
      fields: [
        {
          key: "employee_profile",
          label: "Nama Karyawan",
          class: "width-250",
          sortable: true
        },
        { key: "email", label: "Email", class: "width-60", sortable: true },
        {
          key: "payment_method_name",
          label: "Metode Pembayaran",
          class: "width-150",
          sortable: true
        },
        {
          key: "division_name",
          label: "Divisi",
          class: "width-100",
          sortable: true
        },
        {
          key: "position_name",
          label: "Jabatan",
          class: "width-100",
          sortable: true
        },
        {
          key: "employee_bank_profile",
          label: "Bank Account",
          class: "width-150",
          sortable: true
        },
        { key: "action", class: "width-50 text-center" }
      ]
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  computed: {
    isShow() {
      return localStorage.getItem("nik") === "MBS19080016" ||
        localStorage.getItem("nik") === "MBS19040001"
        ? true
        : false;
    }
  },
  validations() {
    if (this.authorization === 1) {
      return custom_validation.employee.true;
    } else {
      return custom_validation.employee.false;
    }
  },
  methods: {
    init: function(employee_id) {
      this.loading = true;
      this.getAllEmployeeDetail(employee_id);
      this.getDropdown();
    },
    getAllEmployeeDetail: function(employee_id) {
      this.axios
        .get("web/employee/detail/" + employee_id + "/")
        .then(response => {
          this.employeeForm = response.data.data;
          this.employeeForm.start_join = new Date(
            moment(response.data.data.start_join).format()
          );
          this.employeeForm.end_date = new Date(
            moment(response.data.data.end_date).format()
          );
          this.listPositionEmployee = response.data.employee_position;
          this.authorization = response.data.authorization;
        })
        .catch(error => {
          this.expired(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getDropdown: function() {
      this.axios
        .get("web/dropdown/employee/")
        .then(response => {
          this.listParentEmployee = response.data.employee;
          this.listDivisionEmployee = response.data.employee_division;
          this.listPosition = response.data.employee_position;
          this.listPaymentMethodEmployee = response.data.employee_payment_method;
          this.listStatusEmployee = response.data.employee_status;
          this.listEmployeeHO = response.data.employee_head_office;
          this.listEmployeeShift = response.data.employee_shift;
          this.listEmployeeReligion = response.data.employee_religion;
          this.listCompany = response.data.company_for_letter;
          this.listCompanySourceSalary = response.data.company_source_salary;
        })
        .catch(error => {
          this.expired(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getPosition: function(event) {
      this.listPositionEmployee = this.listPosition.filter(
        x => x.division_id === event
      );
    },
    back: function() {
      this.$router.go(-1);
    },
    resetForm: function() {
      for (var a in interfaces.employee) {
        interfaces.employee[a] = null;
      }
      this.employeeForm = interfaces.employee;
    },
    editEmployee: function(evt) {
      evt.preventDefault();
      let messages = (this.employeeForm.status !== '6') ? 'Apakah anda ingin mengubah karyawan ini ?' : 'Semua akses karyawan non aktif akan di hapus, apakah anda yakin?';
      if (confirm(messages)) {
        let employee = this.employeeForm;
        employee.authorization = this.authorization;
        this.axios
          .put("web/employee/change-employee/", employee)
          .then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Ubah Karyawan",
                message: response.data.message
              });
            }
          })
          .catch(error => {
            this.expired(error);
          })
          .finally(() => {
            if (employee.status === 2) {
              this.back();
            } else {
              let route = this.$route.path.split("/");
              this.init(route[4]);
            }
          });
      }
    },
    generateAuth: function(event) {
      //console.log(event);
    },
    expired: function(error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: "Ubah Karyawan",
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  }
};
</script>